import React, { useEffect, useState } from "react";
import Innerbanner from "../../components/inner-banner";
import Datatable from "./datatable";
import {
  getClubList,
  getLeagueList,
  getLeagueTable,
  getRegionList,
} from "../../Services/apis";
import Loader from "../../components/loader";
import MultiSelect from "./multiselect";
import { sortByLabel, sortLeagueOptions } from "../../lib/sorters";
type ClubOption = { value: number; label: string };
type FilterOption = { value: string; label: string };
const Home: React.FC = () => {
  const headingText = "League Table";

  // separate state for each dropdown
  const [selectedTeam, setSelectedTeam] = useState<ClubOption[]>([]);
  const [selectedRegion, setSelectedRegion] = useState<FilterOption[]>([]);
  const [selectedLeague, setSelectedLeague] = useState<FilterOption[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [clubData, setClubData] = useState<ClubOption[]>([]);
  const [RegionData, setRegionData] = useState<FilterOption[]>([]);
  const [LeagueData, setLeagueData] = useState<FilterOption[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  useEffect(() => {
    const fetchData = async (page = 1) => {
      setLoading(true);
      try {
        const clubIds = selectedTeam.map((t) => t.value).join(",");
        const regionValues = selectedRegion.map((r) => r.value).join(",");
        const leagueValues = selectedLeague.map((l) => l.value).join(",");
        const res = await getLeagueTable(
          regionValues,
          leagueValues,
          clubIds,
          page,
        );

        setTableData(res.data || []); // adjust based on API response
        setTotalPage(res?.pagination?.total || 1);
        setCurrentPage(res?.pagination?.current_page || 1);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };
    getClubData();
    fetchData(currentPage);
    getLeagueData();
    getRegionData();
  }, [selectedTeam, selectedRegion, selectedLeague, currentPage]);
  const getClubData = async () => {
    try {
      const res = await getClubList();
      console.log("Club List:", res);
      const formatted = res.data.map((club: any) => ({
        value: club.club_id,
        label: club.name,
      }));
      setClubData(sortByLabel(formatted));
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };
  const getRegionData = async () => {
    try {
      const res = await getRegionList(); // adjust to your service
      const formatted: FilterOption[] = res.data.map((region: string) => ({
        value: region,
        label: region,
      }));
      setRegionData(sortByLabel(formatted));
    } catch (err) {
      console.error("Error fetching regions:", err);
    }
  };

  const getLeagueData = async () => {
    try {
      const res = await getLeagueList(); // adjust to your service
      const formatted: FilterOption[] = res.data.map((league: string) => ({
        value: league,
        label: league,
      }));
      setLeagueData(sortLeagueOptions(formatted));
    } catch (err) {
      console.error("Error fetching leagues:", err);
    }
  };

  return (
    <div className="w-full">
      {loading ? <Loader /> : null}
      <Innerbanner bnrHeading={headingText} />
      <section className="bg-background p-5">
        <div className="container mx-auto">
          <div className="w-full border-b border-gray-300 pb-3 mb-5">
            <div className="w-full flex items-start gap-3 mb-3 flex-wrap flex-col-reverse md:flex-row">
              {/* <SelectDropdown
    label="Select Clubs"
    options={clubData.map((club) => ({
      value: club.club_id,
      label: club.name,
    }))}
    selected={selectedTeam}
    onChange={setSelectedTeam}
  /> */}
              {/* <div className="relative inline-block w-full md:w-64"> */}

              {/* <Select
              isMulti
              options={clubData}
              value={selectedTeam}
              onChange={(value) => setSelectedTeam(value as ClubOption[])}
              placeholder="Select Clubs"
              className="w-full md:w-64"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                  ...base,
                  height: "42px",
                  minHeight: "42px",
                  borderRadius: "9999px",
                  borderColor: "#d1d5db",
                  boxShadow: "none",
                  paddingLeft: "10px",
                }),

                valueContainer: (base) => ({
                  ...base,
                  flexWrap: "nowrap",
                  overflowX: "auto",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }),

                indicatorsContainer: (base) => ({
                  ...base,
                  alignItems: "center",
                }),

                indicatorSeparator: () => ({
                  display: "none",
                }),

                placeholder: (base) => ({
                  ...base,
                  color: "rgb(55 65 81)",
                  fontSize: "14px",
                }),
                dropdownIndicator: (base, state) => ({
                  ...base,
                  color: "rgb(55 65 81)",
                }),
                multiValue: (base) => ({
                  ...base,
                  borderRadius: "12px",
                  margin: "4px 4px",
                }),
              }}
              menuPortalTarget={document.body}
            /> */}

              {/* <Select
  isMulti
  options={clubData}
  value={selectedTeam}
  onChange={(value) => setSelectedTeam(value as ClubOption[])}
  placeholder="Select Clubs"
  className="w-full md:w-64"
  menuPortalTarget={document.body}
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, zIndex: 9999 }),

    control: (base) => ({
      ...base,
      minHeight: 42,
      maxHeight: 80,          
      overflow: "hidden",
      borderRadius: 9999,
    }),

    valueContainer: (base) => ({
      ...base,
      maxHeight: 42,        
      overflowY: "auto",     
      flexWrap: "wrap",      
      paddingRight: 6,
    }),

    multiValue: (base) => ({
      ...base,
      borderRadius: 12,
      margin: "2px",
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),
  }}
/> */}

              <MultiSelect
                options={clubData}
                placeholder="Select Clubs"
                value={selectedTeam}
                onChange={setSelectedTeam}
              />

              <MultiSelect
                options={RegionData}
                placeholder="Select Region"
                value={selectedRegion}
                onChange={setSelectedRegion}
              />
              <MultiSelect
                options={LeagueData}
                placeholder="Select League"
                value={selectedLeague}
                onChange={setSelectedLeague}
              />
            </div>

            {/* Selected Items Display */}
            {(selectedTeam.length > 0 || selectedRegion.length > 0 || selectedLeague.length > 0) && (
              <div className="mt-3 flex flex-wrap gap-2 border rounded-lg p-3 mb-3">
                {selectedTeam.length > 0 && (
                  <div className="flex flex-wrap gap-2 items-center">
                    <span className="text-xs font-semibold text-gray-600">Clubs:</span>
                    {selectedTeam.map((item) => (
                      <span
                        key={item.value}
                        className="bg-[#005486] text-white px-3 py-1 rounded-full text-sm flex items-center gap-2"
                      >
                        {item.label}
                        <button
                          onClick={() => {
                            const updated = selectedTeam.filter(
                              (t) => t.value !== item.value,
                            );
                            setSelectedTeam(updated);
                          }}
                          className="text-red-300 font-bold hover:text-red-100"
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                )}
                
                {selectedRegion.length > 0 && (
                  <div className="flex flex-wrap gap-2 items-center">
                    <span className="text-xs font-semibold text-gray-600">Regions:</span>
                    {selectedRegion.map((item) => (
                      <span
                        key={item.value}
                        className="bg-green-600 text-white px-3 py-1 rounded-full text-sm flex items-center gap-2"
                      >
                        {item.label}
                        <button
                          onClick={() => {
                            const updated = selectedRegion.filter(
                              (r) => r.value !== item.value,
                            );
                            setSelectedRegion(updated);
                          }}
                          className="text-red-300 font-bold hover:text-red-100"
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                )}
                
                {selectedLeague.length > 0 && (
                  <div className="flex flex-wrap gap-2 items-center">
                    <span className="text-xs font-semibold text-gray-600">Leagues:</span>
                    {selectedLeague.map((item) => (
                      <span
                        key={item.value}
                        className="bg-purple-600 text-white px-3 py-1 rounded-full text-sm flex items-center gap-2"
                      >
                        {item.label}
                        <button
                          onClick={() => {
                            const updated = selectedLeague.filter(
                              (l) => l.value !== item.value,
                            );
                            setSelectedLeague(updated);
                          }}
                          className="text-red-300 font-bold hover:text-red-100"
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          <div>
            <Datatable
              data={tableData}
              loading={loading}
              currentPage={currentPage}
              totalPage={totalPage}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
